import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "../styles/linkbuilding_1.css";

handleFloatingPromise(initExpertSite());
